export default __webpack_public_path__ + "static/media/bellIcon-filled.bf92961d.svg";